import React from 'react';
import { string, func, shape } from 'prop-types';
import { BundleAlertmessage } from './BundleAlertmessage';
import { getUnavailableMessage } from '../../utils/product-unavailable-utils';
import { getAlertConfig } from '../../utils/product-bundle-utils';

export const ProductAlertWrapper = ({
  bundle, product, dismissAlert, onSwapBack, variantText
}) => {
  const { unavailableAlertMessage, showProductUpdateAlert } = bundle?.features ?? {};

  const unavailableMessage = getUnavailableMessage({ product, bundleProduct: bundle });

  if (unavailableAlertMessage && unavailableMessage) {
    return (
      <BundleAlertmessage status="error" alertSize="small" content={{ main: unavailableMessage }} />
    );
  }

  if (!showProductUpdateAlert) return null;

  const { alertType } = product || {};

  if (!alertType) return null;

  const config = getAlertConfig({
    alertType,
    variantText
  });

  if (!config) return null;

  return (
    <BundleAlertmessage
      alertSize="small"
      status={config.status}
      content={{
        main: config.messageMain,
        secondary: config.messageSecondary
      }}
      link={{
        show: config.showLink,
        text: config.linkText,
        newLine: true,
        onClick: () => onSwapBack(product.itemId)
      }}
      onClose={() => dismissAlert(product.itemId)}
    />
  );
};

ProductAlertWrapper.propTypes = {
  bundle: shape({}).isRequired,
  product: shape({}).isRequired,
  dismissAlert: func.isRequired,
  onSwapBack: func,
  variantText: string
};

ProductAlertWrapper.defaultProps = {
  onSwapBack: () => {},
  variantText: ''
};

ProductAlertWrapper.displayName = 'ProductAlertWrapper';